import { styled as styled2 } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const activeBackground = token('color.background.neutral.subtle.pressed', colors.N20);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled2.div<{ active?: any }>({
	display: 'flex',
	flexDirection: 'row',
	width: '100%',
	borderRadius: token('space.050', '4px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) => (props.active ? activeBackground : 'none'),
	cursor: 'pointer',
	/* Some space for the focus ring */
	margin: `${token('space.025', '2px')} 0`,
	'&:hover': {
		backgroundColor: activeBackground,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Content = styled2.div({
	display: 'inline-block',
	flexGrow: 1,
	padding: token('space.100', '8px'),
	margin: 'auto',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderIcon = styled2.img<any>({
	width: token('space.600', '48px'),
	height: token('space.600', '48px'),
	maxWidth: token('space.600', '48px'),
	display: 'inline-block',
	margin: token('space.100', '8px'),
	padding: `0 ${token('space.100', '8px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled2.div({
	marginTop: token('space.050', '4px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N300),
});
